import * as React from "react";
import { Box, Typography } from "@mui/material";

const titleSx = {
  color: "text.primary",
  fontFamily: '"Poppins", sans-serif',
  fontSize: { xs: 30, md: 36 },
  fontWeight: 700,
  lineHeight: 1.2,
  mb: 0.75,
};

const subtitleSx = {
  color: "text.secondary",
  fontFamily: '"Poppins", sans-serif',
  fontSize: { xs: 13, md: 14 },
  fontWeight: 400,
  lineHeight: 1.6,
};

export default function PageIntro({ title, children, sx }) {
  return (
    <Box sx={sx}>
      <Typography component="h1" sx={titleSx}>
        {title}
      </Typography>
      <Typography sx={subtitleSx}>{children}</Typography>
    </Box>
  );
}
